export const QUIZ_QUESTIONS_FEATURE_KEY = 'quiz-questions';
